// Einladung als Plattform-Admin annehmen (/admin-invite#token=…): neues Konto anlegen oder bestehendes Konto mit dessen
// Passwort bestätigen. Der Token steht im Fragment und wird nicht an den Server übertragen (ausser in der Anfrage).
import { useState, type FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { ApiError } from '../../api/client';
import { platformAdminApi } from '../../api/platform-admins';
import { Field } from '../../components/ui';
import { AuthLayout } from '../AuthLayout';

export function AdminInvitePage() {
  const { t } = useTranslation();
  const loc = useLocation();
  const token = new URLSearchParams(loc.hash.replace(/^#/, '')).get('token') ?? '';
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState<{ existingAccount: boolean } | null>(null);
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      setDone(await platformAdminApi.accept({ token, displayName: name.trim(), password }));
    } catch (err) {
      if (err instanceof ApiError && err.problem.errors?.token) setError(t('adminInvite.invalid'));
      else if (err instanceof ApiError && err.problem.errors?.password) setError(err.message);
      else setError(err instanceof Error ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <AuthLayout>
      <h1>{t('adminInvite.title')}</h1>
      {done ? (
        <div className="col" style={{ marginTop: 20 }}>
          <div className="hint" role="status">{done.existingAccount ? t('adminInvite.doneExisting') : t('adminInvite.done')}</div>
          <Link className="btn primary" to="/login">{t('login.submit')}</Link>
        </div>
      ) : !token ? (
        <div className="error" role="alert" style={{ marginTop: 16 }}>{t('adminInvite.invalid')}</div>
      ) : (
        <>
          <div className="muted">{t('adminInvite.sub')}</div>
          <form onSubmit={submit}>
            <Field label={t('invite.name')} hint={t('adminInvite.nameHint')}><input value={name} onChange={(e) => setName(e.target.value)} autoComplete="name" /></Field>
            <Field label={t('invite.password')} hint={t('adminInvite.passwordHint')}>
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="new-password" />
            </Field>
            <div className="error" role="alert">{error}</div>
            <button className="btn primary" disabled={busy || !password}>{t('adminInvite.submit')}</button>
          </form>
        </>
      )}
    </AuthLayout>
  );
}
